import { IssueStatus } from "../../models";

export const issueStatusText = {
    [IssueStatus.SUBMITTED]: "Submitted",
    [IssueStatus.ARCHIVED]: "Archived",
    [IssueStatus.APPROVED]: "Approved",
    [IssueStatus.ON_HOLD]: "On Hold",
    [IssueStatus.COMPLETED]: "Completed",
    [IssueStatus.IN_PROGRESS]: "In Progress",
    [IssueStatus.DESIGN_PENDING]: "Design Pending",
    [IssueStatus.DESIGNED]: "Designed",
    [IssueStatus.SCHEDULED]: "Scheduled",
};